if (currentPathObject) {
  if (currentPathObject.template === 'page.boss' || currentPathObject.template === 'page.hugo') {
      let mainContent = document.querySelector('#MainContent');
      if (mainContent) {
        let allLinks = mainContent.querySelectorAll('a');
        allLinks.forEach((link) => {
          let newLink = link.href + `?brand=${currentPathObject.suffix}`;
          link.href = newLink;
        });
      }
  }
  // Check Collection page
  if (currentPathObject.collection_url) {
    const splitPath = currentPathObject.collection_url.split('/collections')[0];
    if (splitPath !== undefined && splitPath === "") {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('brand')) {
        let mainContent = document.querySelector('#MainContent');
        if (mainContent) {
          let allLinks = mainContent.querySelectorAll('a');
          allLinks.forEach((link) => {
            let newLink = link.href + `?brand=${searchParams.get('brand')}`;
            link.href = newLink;
          });
        }
      }
    }
  }
}

class CustomBreadcrumbs extends HTMLElement {
    constructor() {
      super();

      const searchParams = new URLSearchParams(window.location.search);

      this.linkItem = this.querySelector('#brandTitle');
      this.linkItemArrow = this.querySelector('#brandTitleArrow');

      if (searchParams.has('brand')) {
        let brandingName = searchParams.get('brand') === 'boss' ? 'Premium' : 'Contemporary';
        let url = window.location.origin + '/pages/' + searchParams.get('brand');
        this.linkItem.setAttribute('href', url);
        this.linkItem.innerText = brandingName;
        this.linkItem.style.display = "block";
        this.linkItemArrow.style.display = "block";

        // let headerLogo = document.querySelector('#haderLogoWrapper');
        // if (headerLogo) {
        //   let newHtml = headerLogo.innerHTML + `<div class="header--logo-branding ${searchParams.get('brand')}--brand" data-template="page.${searchParams.get('brand')}">
        //     <span>${brandingName.toUpperCase()}</span>
        //   </div>`;
        //   headerLogo.innerHTML = newHtml;
        // }
      }
    }
  }
  
customElements.define("custom-breadcrumbs", CustomBreadcrumbs);